export default __webpack_public_path__ + "static/media/link.98be4a8b.svg";